/* towsons-reviews.js — the shop's own reviews, the little that needs a script (Philip, 4 Oct 2026:
 * our own reviews in place of Judge.me's). Everything else is drawn by Liquid
 * (sections/towsons-product-reviews, towsons-reviews-carousel).
 *
 *   - A review's photo, opened larger in a <dialog> (Escape, the close button or a tap outside
 *     closes it; focus goes back to the photo that opened it). Without this script the photo is
 *     still a link to itself; "Show more reviews" is a <details> and needs no script at all.
 *
 * Loaded by each section that needs it; loaded twice, it is the same one.
 */
(function (root, factory) {
  var isNode = typeof module === 'object' && module && module.exports;
  if (root && root.TowsonsReviews && !isNode) return;
  var api = factory(root);
  if (isNode) module.exports = api;
  if (root) root.TowsonsReviews = api;
})(typeof window !== 'undefined' ? window : null, function (win) {
  'use strict';

  var dialog = null;
  var opener = null;
  function view(button) {
    var src = button.getAttribute('data-trv-photo');
    if (!src) return;
    if (!dialog) {
      dialog = win.document.createElement('dialog');
      dialog.className = 'trv-view';
      dialog.innerHTML = '<button type="button" class="trv-view__close" aria-label="Close">×</button><img alt="">';
      dialog.addEventListener('click', function (e) { if (e.target === dialog || e.target.classList.contains('trv-view__close')) dialog.close(); });
      dialog.addEventListener('close', function () { if (opener && opener.focus) opener.focus(); });
      win.document.body.appendChild(dialog);
    }
    opener = button;
    var img = dialog.querySelector('img');
    img.src = src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=1200';
    var inner = button.querySelector('img');
    img.alt = inner ? inner.alt : '';
    if (typeof dialog.showModal === 'function') dialog.showModal(); else win.open(src, '_blank', 'noopener');
  }

  function onClick(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var photo = t.closest('[data-trv-photo]');
    if (photo && photo.closest('[data-trv]')) { e.preventDefault(); view(photo); }
  }

  if (win && win.document && !win.__towsonsReviewsBound) {
    win.__towsonsReviewsBound = true;
    win.document.addEventListener('click', onClick);
  }

  return { view: view };
});
